import NewB2bOrderPage from '@components/containers/b2b/NewB2bOrderPage';
import AppLayout from '@layouts/AppLayout';
import { type FC } from 'react';

const NewB2bOrder: FC = () => (
    <AppLayout>
        <NewB2bOrderPage />
    </AppLayout>
);

export default NewB2bOrder;
